export default "__VITE_ASSET__CDbaoyrr__"